import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {reposPulseAppBuilder} from './config/app-builder'

import {pulseRoute} from './routes/pulse-route'
import {Pulse} from './routes/Pulse'

export const reposPulseApp = reposPulseAppBuilder.createDataRouterAppFromRoutes([
  pulseRoute.toRoute({Component: Pulse}),
])
registerDataRouterApp(reposPulseApp)
